module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "click": _vm.open
    }
  }, [_vm._t("default"), _vm._v(" "), _c('popup', {
    staticClass: "popup-select",
    attrs: {
      "title": _vm.title
    },
    model: {
      value: (_vm.isActive),
      callback: function($$v) {
        _vm.isActive = $$v
      },
      expression: "isActive"
    }
  }, [_c('div', [(_vm.custom) ? _vm._t("custom") : _vm._e()], 2), _vm._v(" "), (!_vm.custom) ? _c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.options), function(op) {
    return _c('li', {
      key: _vm.index,
      staticClass: "list-item",
      class: {
        selected: _vm.realValue === op[_vm.valueField]
      },
      on: {
        "click": function($event) {
          return _vm.select(op)
        }
      }
    }, [_vm._v("\n        " + _vm._s(op[_vm.descField]) + "\n      ")])
  }), 0) : _vm._e()])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09cb88bd","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PopupSelect.vue
// module id = 781
// module chunks = 0